import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'
import { FormattedMessage } from 'react-intl'
import { Form, Button } from 'lib/ui'
import { useCheckout, useCheckoutContext, BillingAddressFormValues as Values } from 'lib/modules/checkout'

interface Props {
  onCancel?: () => void
}

export const BillingAddressFormActions = ({ onCancel }: Props) => {
  const { setState, state } = useCheckoutContext()
  const { billingAddress } = useCheckout()
  const { dirty } = useFormikContext<Values>()
  const hasErrors = Object.keys({ ...state.billingAddressErrors }).length

  useEffect(() => {
    setState((state) => {
      return {
        ...state,
        isBillingAddressUpdated: !dirty
      }
    })
  }, [setState, dirty])

  return (
    <Form.Actions.Wrapper>
      <Button
        type='submit'
        isLoading={billingAddress.isFetching}
        isDisabled={hasErrors}
      >
        <FormattedMessage id='checkout.billing.action.save' />
      </Button>
      <Button
        type='button'
        onClick={() => {
          setState((state) => {
            return {
              ...state,
              isBillingAddressUpdated: true
            }
          })
          onCancel?.()
        }}
        skin={Button.SKIN.OUTLINE}
        isDisabled={billingAddress.isFetching}
      >
        <FormattedMessage id='checkout.billing.action.cancel' />
      </Button>
    </Form.Actions.Wrapper>
  )
}
